import { render, staticRenderFns } from "./TreatmentSetItemListTableRow.vue?vue&type=template&id=db898be4&scoped=true&"
import script from "./TreatmentSetItemListTableRow.vue?vue&type=script&lang=js&"
export * from "./TreatmentSetItemListTableRow.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentSetItemListTableRow.vue?vue&type=style&index=0&id=db898be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db898be4",
  null
  
)

export default component.exports